import type { ServiceCategoryRow } from '@/api/booking/getServiceCategoriesQuery';
import { Logger } from '@/utils/logging';

interface GetVisibleL1CategoriesParams {
  rows: ServiceCategoryRow[];
  /** When given, only these L1 ids are shown (plus `keepL1Ids`). */
  allowedL1Ids?: ReadonlySet<string>;
  /** L1 ids that stay visible even when not in `allowedL1Ids`. */
  keepL1Ids?: ReadonlySet<string>;
}

export function getVisibleL1Categories({
  rows,
  allowedL1Ids,
  keepL1Ids,
}: GetVisibleL1CategoriesParams): ServiceCategoryRow[] {
  const l1Ids = new Set(
    rows.filter((row) => row.parentCategoryId == null).map((row) => row.id),
  );
  const orphanIds = rows
    .filter(
      (row) => row.parentCategoryId != null && !l1Ids.has(row.parentCategoryId),
    )
    .map((row) => row.id);

  if (orphanIds.length > 0) {
    Logger.debug('[getVisibleL1Categories] L2 rows without an L1 row', {
      orphanIds,
    });
  }

  return rows
    .filter(
      (row) =>
        row.parentCategoryId == null &&
        row.visible !== false &&
        (!allowedL1Ids ||
          allowedL1Ids.has(row.id) ||
          keepL1Ids?.has(row.id) === true),
    )
    .sort(
      (a, b) =>
        a.position - b.position || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0),
    );
}
